module.exports = __webpack_public_path__ + "img/collection-memoireRingsExclusive@2x.d048b40.webp";